'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NewFolderView;

var _preact = require('preact');

function NewFolderView(props) {
  if (!props.visible) {
    return null;
  }
  return (0, _preact.h)(
    'div',
    { 'class': 'window' },
    (0, _preact.h)(
      'div',
      { 'class': 'heading' },
      (0, _preact.h)(
        'b',
        null,
        'new folder'
      ),
      (0, _preact.h)(
        'div',
        { 'class': 'buttons' },
        (0, _preact.h)(
          'button',
          { onClick: props.onClose },
          'x'
        )
      )
    ),
    (0, _preact.h)('input', { type: 'text',
      autofocus: true,
      placeholder: 'Enter a name',
      value: props.name,
      onChange: props.onChange
    })
  );
}


//////////////////
// WEBPACK FOOTER
// ./client/components/Browser/Folders/NewFolderView.jsx
// module id = 75
// module chunks = 0